<template>
  <section id="mass-suspend" class="text-center">
    <h3>You are about to mass-suspend the below tariffs</h3>
    <div class="form-group">
      <label for="reason-suspend" class="form-label">Please enter a reason for the mass-suspension of tariffs</label>
      <textarea class="form-control" v-model="reason" id="reason-suspend"></textarea>
    </div>
    <div v-if="!confirming" :class="[ isValid ? '' : 'disabled', 'btn btn-danger' ]" @click="confirm">
      Confirm mass-suspension
    </div>
    <div v-if="confirming">
      <h5>
        Are you sure?
      </h5>
      <div class="btn btn-success" @click="update">
        Confirm
      </div>
      <div class="btn btn-danger" @click="confirming = false">
        Cancel
      </div>
    </div>
  </section>
</template>
<script>
  import event from '../../../../event'
  export default {
    name: 'MassSuspend',
    data () {
      return {
        reason: null,
        confirming: false
      }
    },
    computed: {
      isValid () {
        return this.reason !== null && this.reason.trim().length
      }
    },
    methods: {
      confirm () {
        if (!this.isValid) {
          event.$emit('toast', { type: 'warning', message: 'Please ensure you add a valid reason before suspending tariffs' })
        } else {
          this.confirming = true
        }
      },
      update () {
        if (!this.isValid) {
          event.$emit('toast', { type: 'warning', message: 'Please ensure you add a valid reason before suspending tariffs' })
        } else {
          this.confirming = false
          this.$emit('suspend', this.reason)
        }
      }
    }
  }
</script>
<style>
  #mass-suspend {
    padding: 10px 10px 30px 10px;
    background-color: #eee;
    margin: 0 10px;
    -webkit-box-shadow: 0px 0px 10px 2px rgba(68,68,68,0.82);
    -moz-box-shadow: 0px 0px 10px 2px rgba(68,68,68,0.82);
    box-shadow: 0px 0px 10px 2px rgba(68,68,68,0.82);
    transition: all 0.5s;
  }
  #mass-suspend:hover {
    -webkit-box-shadow: 0px 0px 20px 5px rgba(68,68,68,0.82);
    -moz-box-shadow: 0px 0px 20px 5px rgba(68,68,68,0.82);
    box-shadow: 0px 0px 20px 5px rgba(68,68,68,0.82);
  }
</style>



// WEBPACK FOOTER //
// MassSuspend.vue?262a178a